import { useQuery } from 'react-query';
import { useClient } from 'hooks/useClient';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { keyBy } from 'lodash/fp';

type FeatureOptions = {
  team: string;
};

export default function useGetFeatures(options: FeatureOptions) {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3(),
  });

  const query = useQuery(['get-features', options.team], async () => {
    return client.getFeatures(options.team).then(keyBy('feature'));
  });

  return query;
}
